export default __webpack_public_path__ + "static/media/marauders-map-v3-03-01.41117cd9.jpg";